<template>
    <div>
        <van-tabbar v-model="active" active-color="#000000" inactive-color="#000" placeholder>
            <van-tabbar-item replace to="/mobile" :badge="xiaonum == 0 ? '' : xiaonum">
                <span>{{ table[0].text }}</span>
                <template #icon="props">
                    <img :src="props.active ? table[0].active : table[0].inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/gz">
                <span>{{ table[1].text }}</span>
                <template #icon="props">
                    <img :src="props.active ? table[1].active : table[1].inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/tz" :badge="xtxiaonum == 0 ? '' : xtxiaonum">
                <span>{{ table[2].text }}</span>
                <template #icon="props">
                    <img :src="props.active ? table[2].active : table[2].inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/ls">
                <span>{{ table[3].text }}</span>
                <template #icon="props">
                    <img :src="props.active ? table[3].active : table[3].inactive" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {  getnotReadNum } from '@/api/index.js'

export default {
    name: '',
    props: {
        uactive: {
            type: Number
        }
    },
    computed: {
        ...mapState(['xiaonum', 'xtxiaonum'])
    },
    watch: {
        uactive: {
            handler(newVal, oldVal) {
                //监听info对象变化
                if (newVal) {
                    this.active = newVal
                }
            },
            deep: true, //深度监听
            immediate: true
        }
    },
    data() {
        return {
            active: 0,
            table: [
                {
                    text: '聊天',
                    active: require('../../assets/mobile/ltact.png'),
                    inactive: require('../../assets/mobile/lt.png'),
                },
                {
                    text: '关注',
                    active: require('../../assets/mobile/gzact.png'),
                    inactive: require('../../assets/mobile/gz.png'),
                },
                {
                    text: '通知',
                    active: require('../../assets/mobile/tzact.png'),
                    inactive: require('../../assets/mobile/tz.png'),
                },
                {
                    text: '历史',
                    active: require('../../assets/mobile/lsact.png'),
                    inactive: require('../../assets/mobile/ls.png'),
                },
            ],
        }
    },
    mounted() {
        getnotReadNum().then(ress => {
            if (ress.code == 1) {
                this.$store.commit('SetXtxiaonum', ress.data.num)
            }
        })
    },
    methods: {

    },
}
</script>
<style lang='scss' scoped></style>